/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
import moment from 'moment';
import { View } from 'react-big-calendar';
import { Recruiter } from '../../../../firebase/firestore/documents/recruiter';
import { getConsistentDateFormat } from '../../../../utils/dateUtils';

export interface DateRange {
  fromDate: Date;
  toDate: Date;
}

export const moveCurrentUserIdToFirstIndex = (arr: Recruiter[], fromIndex: number, toIndex: number): Recruiter[] => {
  const arrCopy = [...arr];
  const element = arrCopy[fromIndex];
  arrCopy.splice(fromIndex, 1);
  arrCopy.splice(toIndex, 0, element);
  return arrCopy;
};

export const getDateRangeForView = (givenDate: Date, view: View, tz?: string): DateRange => {
  switch (view) {
    case 'month':
      return {
        fromDate: tz
          ? moment.tz(givenDate, tz).startOf('month').subtract(6, 'days').toDate()
          : moment(givenDate).startOf('month').subtract(6, 'days').toDate(),
        toDate: tz
          ? moment.tz(givenDate, tz).endOf('month').add(6, 'days').toDate()
          : moment(givenDate).endOf('month').add(6, 'days').toDate(),
      };
    case 'day':
      return {
        fromDate: tz ? moment.tz(givenDate, tz).startOf('day').toDate() : moment(givenDate).startOf('day').toDate(),
        toDate: tz ? moment.tz(givenDate, tz).endOf('day').toDate() : moment(givenDate).endOf('day').toDate(),
      };
    case 'week':
      return {
        fromDate: tz ? moment.tz(givenDate, tz).startOf('week').toDate() : moment(givenDate).startOf('week').toDate(),
        toDate: tz ? moment.tz(givenDate, tz).endOf('week').toDate() : moment(givenDate).endOf('week').toDate(),
      };
    default:
      return { fromDate: givenDate, toDate: givenDate };
  }
};

export const dayFormat = (date: Date, culture: any, localizers: any): string => `${localizers.format(date, 'ddd DD', culture)}`;

export function dayRangeHeaderFormat(_ref3: any, culture: any, local: any): string {
  const { start, end } = _ref3;
  return `${local.format(
    start,
    `${getConsistentDateFormat(start, 'noYear', undefined, undefined, true)}`,
    culture,
  )} - ${local.format(end, `${getConsistentDateFormat(end, 'noYear', undefined, undefined, true)}`, culture)}`;
}
